import React from 'react'
import { useLocation } from 'react-router-dom'
import { Container } from 'reactstrap'
import Breadcrumbs from '../../components/Common/Breadcrumb'
import OxxoReceipt from '../../components/Common/OxxoReceipt'

const OxxoPage = (props) => {
  const { state } = useLocation()

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            title="Carrito"
            breadcrumbItem={`Recibo de pago`}
            parentLink={`/carrito`}
          />
          <OxxoReceipt data={state.oxxoResponse} />
        </Container>
      </div>
    </React.Fragment>
  )
}

export default OxxoPage
